import AssetRequestModal from './AssetRequestModal';

export default AssetRequestModal;
